import React from 'react';
import Select from 'react-select';

const StyledSelect = ({ options, ...props }) => {
  const { appTheme } = props;
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: 'transparent',
      borderColor: state.isFocused ? 'rgb(99 102 241)' : '#d1d5db',
      '&:hover': {
        borderColor: 'rgb(99 102 241)',
      },
      boxShadow: state.isFocused ? '0 0 0 1px rgb(99 102 241)' : 'none',
      borderRadius: '0.5rem',
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: 'var(--tw-prose-background)',
      border: '1px solid var(--tw-prose-borders)',
      borderRadius: '0.5rem',
      boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)',
      zIndex: 50,  // Added z-index
    }),
    menuPortal: (provided) => ({
      ...provided,
      zIndex: 9999  // High z-index for the portal
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? '#2563eb' : state.isFocused
          ? '#bfdbfe' : (appTheme === 'dark')
            ? '#475569' : 'white',
      color: state.isSelected ? 'white' :
        (appTheme === 'dark') ? (state.isFocused ? 'black' : 'white') : 'black',
      cursor: 'pointer',
      padding: '8px 12px',
      ':active': {
        backgroundColor: '#2563eb',
      },
      zIndex: 50
    }),
    singleValue: (provided) => ({
      ...provided,
      color: 'var(--tw-prose-body)',
    }),
    input: (provided) => ({
      ...provided,
      color: 'var(--tw-prose-body)',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: 'var(--tw-prose-secondary)',
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: 'var(--tw-prose-pre-bg)',
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: 'var(--tw-prose-body)',
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: 'var(--tw-prose-secondary)',
      ':hover': {
        backgroundColor: 'rgba(239, 68, 68, 0.1)',
        color: 'rgb(239 68 68)',
        zIndex: 9999
      },
    }),
  };

  return (
    <div className="w-full relative">
      <Select
        options={options}
        styles={customStyles}
        className="w-full"
        classNamePrefix="select"
        menuPortalTarget={document.body}  // Add portal support
        menuPosition="fixed"  // Use fixed positioning
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary: 'rgb(99 102 241)',
            primary75: 'rgb(99 102 241 / 75%)',
            primary50: 'rgb(99 102 241 / 50%)',
            primary25: 'rgb(99 102 241 / 25%)',
          },
        })}
        {...props}
      />
    </div>
  );
};

export default StyledSelect;